import React from 'react'
import classNames from 'classnames'
import { Icon } from '@scentregroup/ui'
import style from './index.module.scss'

const TabsHeader: React.FC<
  React.PropsWithChildren<{
    selectedTab: number
    headings: string[]
    onTabHeadingClick: (activeTabIndex: number) => void
    fullWidth?: boolean
    disabledTabVal?: string
    className?: string
  }>
> = ({
  headings,
  selectedTab,
  onTabHeadingClick,
  fullWidth = false,
  disabledTabVal,
  className,
}) => {
  const iconType = (heading: string): string | null => {
    switch (heading) {
      case 'Nearby':
        return 'location-drop-pin'
      case 'All centres':
        return 'list-view'
      default:
        return null
    }
  }

  return (
    <div
      className={classNames(
        fullWidth ? style.tabBarFull : style.tabBar,
        className
      )}
    >
      <ul
        id="container"
        className={
          fullWidth ? style.tabHeaderFull : classNames(style.tabHeader)
        }
        role="tablist"
      >
        {headings.map((heading, i) => {
          const isDisabled = disabledTabVal === heading

          return (
            <li key={`tabHeading${i}`} role="presentation">
              {iconType(heading) && (
                <Icon
                  className={classNames(style.tabIcon, {
                    [style.tabIconDisabled]: isDisabled,
                  })}
                  type={iconType(heading)}
                />
              )}
              <button
                data-test-id="tab-button"
                disabled={isDisabled}
                className={classNames(
                  fullWidth ? style.tabTitleFull : style.tabTitle,
                  {
                    [style.activeTabTitle]: selectedTab === i,
                    [style.buttonDisabled]: isDisabled,
                  }
                )}
                aria-controls={`tabpanel${i}`}
                aria-selected={selectedTab === i}
                role="tab"
                onClick={() => onTabHeadingClick(i)}
              >
                {heading}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default TabsHeader
